import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import AboutGuide from "../components/AboutGuide";
import WhyDifferent from "../components/WhyDifferent";
import PortoDifferentEyes from "../components/PortoDifferentEyes";
import TourDetails from "../components/TourDetails";
import RouteSection from "../components/RouteSection";
import Pricing from "../components/Pricing";
import Booking from "../components/Booking";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingWhatsapp from "../components/FloatingWhatsapp";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F7F1E8] text-[#2D3640]">
      <Header />
      <main>
        <Hero />
        <AboutGuide />
        <WhyDifferent />
        <PortoDifferentEyes />
        <TourDetails />
        <RouteSection />
        <Pricing />
        <Booking />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}
